import Popup from '../popup'

export default class MobileNav extends Popup {
	static title = 'mobile-nav'

	init() {
		super.init()

		this.getElements('item__open-sub').forEach(el => this.openSubNav(el))
		this.getElements('item--back').forEach(el => this.backToMainMenu(el))

		this.mobileNavToggleButton = this.getElement('toggle')
		this.shoppingcartPopup = document.querySelector('.shoppingcart-popup')

		if (this.mobileNavToggleButton) {
			this.mobileNavToggleButton.addEventListener('click', () => {
				this.toggle()
			})
		}
	}

	openSubNav(element) {
		if (!element.hasAttribute('data-category-id')) {
			return
		}

		element.addEventListener('click', () => {
			this.getElements('list').forEach(listElement => {
				if (
					listElement.hasAttribute('data-parent-category-id') &&
					listElement.getAttribute('data-parent-category-id') ===
						element.getAttribute('data-category-id')
				) {
					listElement.classList.add('mobile-nav__list--active')
					return
				}

				listElement.classList.remove('mobile-nav__list--active')
			})
		})
	}

	toggleShoppingcartPopup() {
		if (!this.isValidBlock(this.shoppingcartPopup)) {
			return
		}
		this.shoppingcartPopup.ref.toggle()
	}

	backToMainMenu(element) {
		element.addEventListener('click', () => {
			this.getElement('list--main').classList.add('mobile-nav__list--active')
			element.parentNode.classList.remove('mobile-nav__list--active')
		})
	}
}
